import { SubmitCampaign } from "types/Campaign";
import { store } from "utils/store";

export const initialSubmitCampaignFields = (
  campaignType: string,
  previousData?: SubmitCampaign
) => {
  return {
    plainTextOfCampaignContent: [] as string[],
    abTestDetails: {
      testingVariants: previousData?.abTestDetails?.testingVariants || 0,
      testingVariable: previousData?.abTestDetails?.testingVariable || "",
      testingValues: previousData?.abTestDetails?.testingValues || [],
      ratioForTesting: previousData?.abTestDetails?.ratioForTesting || 0,
      resultsAfterType: previousData?.abTestDetails?.resultsAfterType || "",
      resultsAfterInterval:
        previousData?.abTestDetails?.resultsAfterInterval || 0,
      winningExecutionType:
        previousData?.abTestDetails?.winningExecutionType || "",
      winningMetric: previousData?.abTestDetails?.winningMetric || "",
    },
    campaign: {
      id: previousData?.campaign?.id || 0,
      name: previousData?.campaign?.name || "",
      displayName:
        previousData?.campaign?.displayName || store.getState().auth.userName,
      subject: previousData?.campaign?.subject || "",
      userId: previousData?.campaign?.userId ?? store.getState().auth.userId,
      fromId: previousData?.campaign?.fromId ?? store.getState().auth.userId,
      fromIdEmail:
        previousData?.campaign?.fromIdEmail ?? "",
      senderEmail:
        previousData?.campaign?.senderEmail || "",
      replyToEmail:
        previousData?.campaign?.replyToEmail || "",
      scheduleTime: previousData?.campaign?.scheduleTime || "",
      type: previousData?.campaign?.type || campaignType,
      testIds: previousData?.campaign?.testIds || [],
      status: previousData?.campaign?.status || "Draft",
      content: previousData?.campaign?.content || "",
      contentJson: previousData?.campaign?.contentJson || ({} as any),
      contentPlain: previousData?.campaign?.contentPlain || "",
      parentId: previousData?.campaign?.parentId || "",
      attachments: previousData?.campaign?.attachments || ({} as any),
      optimalSendTime: previousData?.campaign?.optimalSendTime || "",
    },
    campaignData: {
      phishingCheck: {
        spamPrediction:
          previousData?.campaignData?.phishingCheck?.spamPrediction || 0,
        spam: previousData?.campaignData?.phishingCheck?.spam || false,
        phishing: previousData?.campaignData?.phishingCheck?.phishing || false,
        phishingPercentage:
          previousData?.campaignData?.phishingCheck?.phishingPercentage || 0,
      },
      domainName: previousData?.campaignData?.domainName || "",
      messageId: previousData?.campaignData?.messageId || "",
    },
    campaignSegments: {
      segmentTypeId: previousData?.campaignSegments?.segmentTypeId || 1,
      segmentIds: previousData?.campaignSegments?.segmentIds || [],
      recipients: previousData?.campaignSegments?.recipients || 0,
    },
  };
};

export const initialSubmitSocialCampaignFields = () => {
  return {
    name: "",
    socialAppName: "",
    scheduleTime: "",
    socialSource: "",
    profilePicture: "",
    userName: "",
    pageName: "",
    owner: store.getState().auth.email,
    socialCampaign: {
      link: [],
      message: "",
      pageId: "",
    },
  };
};
